import React from "react";
import { useAuth } from "@/context/AuthContext";
import ConversationList from "@/components/messaging/ConversationList";

const EmployerMessages = () => {
    const { user } = useAuth();
    return (
        <div className="max-w-4xl mx-auto px-4 py-8 sm:py-10" data-testid="employer-messages-page">
            <ConversationList
                viewerRole="employer"
                viewerUserId={user?.user_id}
                title="Candidate messages"
                emptyLabel="You haven't started any threads yet. Open Talent Marketplace or Applications and hit Message on a candidate card."
            />
        </div>
    );
};

export default EmployerMessages;
